"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var Checkmark = function (_a) {
    var selected = _a.selected;
    return (React.createElement("div", { style: selected
            ? { left: "4px", top: "4px", zIndex: 1 }
            : { display: "none" } },
        React.createElement("svg", { style: { fill: "white", position: "absolute" }, width: "24px", height: "24px" },
            React.createElement("circle", { cx: "12.5", cy: "12.2", r: "8.292" })),
        React.createElement("svg", { style: { fill: "#06befa", position: "absolute" }, width: "24px", height: "24px" },
            React.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" }))));
};
var imgStyle = {
    transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s"
};
var selectedImgStyle = {
    transform: "translateZ(0px) scale3d(0.9, 0.9, 1)",
    transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s"
};
var cont = {
    backgroundColor: "#eee",
    cursor: "pointer",
    overflow: "hidden",
    left: 0,
    top: 0
};
var SelectedImage = function (_a) {
    var index = _a.index, photo = _a.photo, margin = _a.margin, direction = _a.direction, top = _a.top, left = _a.left, selected = _a.selected, onClick = _a.onClick;
    var _b = react_1.useState(selected), isSelected = _b[0], setIsSelected = _b[1];
    var sx = (100 - (30 / photo.width) * 100) / 100;
    var sy = (100 - (30 / photo.height) * 100) / 100;
    selectedImgStyle.transform = "translateZ(0px) scale3d(" + sx + ", " + sy + ", 1)";
    if (direction === "column") {
        cont.left = left;
        cont.top = top;
    }
    var handleOnClick = function (e) {
        setIsSelected(!isSelected);
        onClick(e, { photo: photo, index: index, isSelected: isSelected });
    };
    react_1.useEffect(function () {
        setIsSelected(selected);
    }, [selected]);
    return (React.createElement("div", { style: __assign({ margin: margin, height: photo.height, width: photo.width }, cont), className: !isSelected ? "not-selected" : "" },
        React.createElement(Checkmark, { selected: isSelected ? true : false }),
        React.createElement("img", __assign({ alt: photo.title, style: isSelected ? __assign(__assign({}, imgStyle), selectedImgStyle) : __assign({}, imgStyle) }, photo, { onClick: handleOnClick })),
        React.createElement("style", null, ".not-selected:hover{outline:2px solid #06befa}")));
};
exports.default = SelectedImage;
//# sourceMappingURL=SelectedImageRenderer.js.map